interface Product {
  oos_flag?: number
  is_new?: number
  back_in_stock?: number
  sold_out?: number
  low_stock?: number
  best_seller?: number
  tags?: string[]
  leaving_soon?: number
}

export interface TagCounts {
  leaving_soon_product_count: number
  oos_product_count: number
  new_stock_product_count: number
  back_in_stock_product_count: number
  sold_out_product_count: number
  low_stock_product_count: number
  best_seller_product_count: number
}

const initialTagCounts: TagCounts = {
  oos_product_count: 0,
  new_stock_product_count: 0,
  back_in_stock_product_count: 0,
  sold_out_product_count: 0,
  low_stock_product_count: 0,
  best_seller_product_count: 0,
  leaving_soon_product_count: 0,
}

export const getProductTagsDataForBatchedAnalytics = (products: Product[] = []): TagCounts => {
  return products.reduce(
    (
      tagCounts,
      { oos_flag = 0, is_new = 0, back_in_stock = 0, sold_out = 0, low_stock = 0, best_seller = 0, leaving_soon = 0 },
    ) => {
      tagCounts.oos_product_count += oos_flag
      tagCounts.new_stock_product_count += is_new
      tagCounts.back_in_stock_product_count += back_in_stock
      tagCounts.sold_out_product_count += sold_out
      tagCounts.low_stock_product_count += low_stock
      tagCounts.best_seller_product_count += best_seller
      tagCounts.leaving_soon_product_count += leaving_soon
      return tagCounts
    },
    { ...initialTagCounts },
  )
}

export const getProductTagsDataForBatchedAnalyticsFromTags = (products: Product[] = []): Record<string, number> => {
  const initialTagCounts: Record<string, number> = {}
  return products.reduce((tagCounts, { tags = [] }) => {
    tags.forEach(tag => {
      let formateedTagName = tag.replace(/ /g, '_').toLowerCase() // e.g. 'Leaving Soon' => 'leaving_soon'
      formateedTagName = formateedTagName + '_product_count' // e.g. 'leaving_soon' => 'leaving_soon_product_count'
      tagCounts[formateedTagName] = (tagCounts?.[formateedTagName] || 0) + 1
    })
    return tagCounts
  }, initialTagCounts)
}
